export const fetchLatestUploadsURL = () => {
  return `/general/latest_upload`;
};

export const bulkUploadDocumentsURL = () => {
  return `/general/bulk_upload`;
};

export const downloadFormatURL = (bulk_identifier) => {
  return `/general/bulk_upload/download?bulk_uploader_identifier=${bulk_identifier}`;
};
